
export default function Footer() {
  return (
    <footer className="bg-[#f5f5f4] text-[#09090b] border-t border-[#e4e4e7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/151e34d9a5807cd608014213251345d2/8df0e05ed936c289fbef98f2071860df.png"
                alt="HushLegal"
                className="h-12 w-auto"
              />
              <span className="text-gray-900 text-2xl font-black">HushLegal</span>
            </div>
            <p className="font-harvey-sans text-sm text-[#52525b] leading-relaxed">
              Secure legal communication platform designed for attorneys and clients who value privacy.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-harvey-serif text-base font-semibold mb-4">Contact</h3>
            <a
              href="mailto:sales@hushlegal.com"
              className="font-harvey-sans text-sm text-[#52525b] hover:text-[#8B4513] transition-colors cursor-pointer"
            >
              sales@hushlegal.com
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#e4e4e7] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-harvey-sans text-sm text-[#71717a]">
            © 2026 HushLegal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
